import { render, staticRenderFns } from "./ObjectList.vue?vue&type=template&id=20a37a82&scoped=true"
import script from "./ObjectList.vue?vue&type=script&lang=js"
export * from "./ObjectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a37a82",
  null
  
)

export default component.exports